import styled from '@emotion/styled';

import { blockingColors, blockingMetrics } from '../tokens';

export const AlertRoot = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 11px 13px;
  background: ${blockingColors.alertBg};
  border: 1px solid ${blockingColors.alertBg};
  border-radius: ${blockingMetrics.radius};
`;

export const IconSlot = styled('span')`
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: 18px;
  height: 18px;
  color: ${blockingColors.alertIcon};

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const AlertText = styled('p')`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  color: ${blockingColors.text};

  strong {
    font-weight: 700;
  }
`;
